/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export class LoginUserInput {
	email: string = ''

	password: string = ''
}